
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBackwardFast as ObiBackwardFastElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-backward-fast.js';
 
 
 

 
 export const ObiBackwardFast = createComponent({
   react: React,
   tagName: 'obi-backward-fast',
   elementClass: ObiBackwardFastElement,
   events: {
     
   }
  });
 
 